<template>
  <v-container
    fluid
    grid-list-md
    text-xs-center
    subgroups-wrapper
    style="min-height: 93.4vh"
  >
    <v-layout row wrap>
      <v-toolbar
        scroll-target="#scrolling-home"
        style="height: 74px; z-index: 1"
      >
        <v-toolbar-title v-show="!$vuetify.breakpoint.xsOnly"
          >Subgrupos</v-toolbar-title
        >
        <v-toolbar-title
          v-show="$vuetify.breakpoint.xsOnly"
          style="width: 100%"
        >
          <v-layout class="mt-3" row align-center justify-center>
            <v-flex xs10 class="titleSearch">
              <v-text-field
                flat
                label="Buscar"
                prepend-inner-icon="search"
                solo-inverted
                clearable
                @click:append-outer="filterSearch"
                @click:clear="filterSearch"
                @keyup.enter="filterSearch"
                v-model="search"
              />
            </v-flex>
            <v-flex xs2>
              <v-btn
                @click="deleteSubgroups"
                icon
                v-if="permits['UPDATE_SUBGROUPS']"
                :disabled="!(selected.length > 0)"
              >
                <v-icon color="primary">delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-toolbar-title>
        <v-layout
          style="margin-top: 5px"
          wrap
          fill-height
          justify-end
          v-if="!$vuetify.breakpoint.xsOnly"
        >
          <v-flex xs4 sm4 offset-sm2 class="titleSearch">
            <v-text-field
              flat
              label="Buscar"
              append-outer-icon="search"
              clearable
              solo-inverted
              hide-details
              @click:append-outer="filterSearch(false)"
              @click:clear="filterSearch(true)"
              @keyup.enter="filterSearch(false)"
              v-model="search"
            />
          </v-flex>
          <v-flex xs1>
            <v-tooltip bottom justify-end>
              <template v-slot:activator="{ on }" justify-end>
                <v-btn
                  v-on="on"
                  @click="deleteSubgroups"
                  icon
                  v-if="permits['UPDATE_SUBGROUPS']"
                  :disabled="!(selected.length > 0)"
                >
                  <v-icon color="primary">delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </v-flex>
        </v-layout>

        <v-tooltip right v-if="permits['ADD_SUBGROUPS']">
          <v-btn
            color="gradiente"
            dark
            :small="$vuetify.breakpoint.xsOnly"
            absolute
            bottom
            left
            fab
            slot="activator"
            @click="createNewSubgroup"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <span>Crear subgrupo</span>
        </v-tooltip>
      </v-toolbar>
      <v-container elevation-2 fluid id="scrolling-activity" class="table-full">
        <v-layout row wrap>
          <v-flex xs12>
            <v-data-table
              v-model="selected"
              ref="subgroupsTable"
              select-all
              :headers="headers"
              :rows-per-page-items="[25, 50, 100]"
              rows-per-page-text="Registros por página"
              :items="subgroupsMod"
              :loading="working.wSubgroups"
              :pagination.sync="pagination"
              :total-items="totalItemsFromBackend"
              item-key="id"
              :headers-length="9"
              no-results-text="No se encontraron coincidencias"
              :no-data-text="
                permits['WATCH_SUBGROUPS']
                  ? working.wSubgroups
                    ? 'Cargando'
                    : subgroups.length > 0
                    ? ''
                    : 'No hay subgrupos'
                  : 'No tienes permiso de ver subgrupo'
              "
            >
              <template v-slot:headers="props">
                <tr>
                  <th class="text-xs-left" :style="{ width: '78px' }">
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      color="primary"
                      hide-details
                      @click.stop="toggleAll"
                      v-if="permits['UPDATE_SUBGROUPS']"
                    />
                  </th>
                  <th class="text-xs-left td-cell-150">Nivel</th>
                  <th class="text-xs-left td-cell-150">Grado</th>
                  <th class="text-xs-left td-cell-150">Grupo</th>
                  <th class="text-xs-left td-cell-150">Subgrupo</th>
                  <th class="text-xs-left td-cell-150">Días</th>
                  <th class="text-xs-left td-cell-150">Estatus</th>
                  <th class="text-xs-left td-cell-150">Inicio</th>
                  <th class="text-xs-left td-cell-150">Fin</th>
                  <th class="text-xs-right td-cell-250">&nbsp;</th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr :active="props.selected">
                  <td class="text-xs-left" :style="{ width: '78px' }">
                    <v-checkbox
                      v-if="permits['UPDATE_SUBGROUPS']"
                      color="primary"
                      v-model="props.selected"
                      primary
                      hide-details
                    />
                  </td>
                  <td class="text-xs-left td-cell-150">
                    <CustomTooltipOverflowText>
                      {{ props.item.level.typeLevel }}
                    </CustomTooltipOverflowText>
                  </td>
                  <td class="text-xs-left td-cell-150">
                    <CustomTooltipOverflowText>
                      {{
                        props.item.gradeGroup
                          ? props.item.gradeGroup.grade
                          : '---'
                      }}
                    </CustomTooltipOverflowText>
                  </td>
                  <td class="text-xs-left td-cell-150">
                    <CustomTooltipOverflowText>
                      {{
                        props.item.gradeGroup
                          ? props.item.gradeGroup.group
                          : '---'
                      }}
                    </CustomTooltipOverflowText>
                  </td>
                  <td class="text-xs-left td-cell-150">
                    <CustomTooltipOverflowText>
                      {{ props.item.name }}
                    </CustomTooltipOverflowText>
                  </td>
                  <td class="text-xs-left td-cell-150">
                    {{ props.item | daysFilter }}
                  </td>
                  <td class="text-xs-left td-cell-150">
                    <v-tooltip
                      bottom
                      v-if="
                        props.item.expireWarning && permits['UPDATE_SUBGROUPS']
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-bind="attrs"
                          class="expiration-warning canRenovate"
                          v-on="on"
                          @click="renewSubgroup(props.item)"
                        >
                          {{ props.item.statusText }}
                          <v-icon>warning</v-icon>
                        </span>
                      </template>
                      <span>Renovar Subgrupo</span>
                    </v-tooltip>
                    <template v-else>
                      <span
                        :class="{
                          'expiration-warning': props.item.expireWarning,
                        }"
                        >{{ props.item.statusText }}</span
                      >
                    </template>
                  </td>
                  <td class="text-xs-left td-cell-150">
                    {{ props.item.startDateText }}
                  </td>
                  <td class="text-xs-left td-cell-150">
                    {{ props.item.finalDateText }}
                  </td>
                  <td class="text-xs-left td-cell-250">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          @click="viewSubgroup(props.item)"
                          icon
                          :title="'Grupo híbrido con ID ' + props.item.id"
                          :disabled="!permits['WATCH_SUBGROUPS']"
                        >
                          <v-icon>visibility</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver Subgrupo</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          @click="editSubgroup(props.item)"
                          icon
                          :disabled="
                            !permits['UPDATE_SUBGROUPS'] ||
                            props.item.status == 'EXPIRED'
                          "
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar Subgrupo</span>
                    </v-tooltip>

                    <!-- <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" @click="deleteSubgroup(props.item)" icon :disabled="!permits['UPDATE_SUBGROUPS']">
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar Subgrupo</span>
                    </v-tooltip>  -->
                  </td>
                </tr>
              </template>
              <template v-slot:pageText="props">
                {{ props.pageStart }} - {{ props.pageStop }} de
                {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>

    <CreateSubgroup
      v-model="modals.createSubgroup"
      @created="onNewSubgroup"
      @onClosed="onCancel"
      @loading="onLoading"
      :levels="this.levels"
    />

    <EditSubgroup
      v-model="modals.editSubgroup"
      :subgroup="subgroup"
      :renew="modals.renewSubgroup"
      @cancelled="onCancel"
      @created="onEditSubgroup"
    />

    <SummarySubgroup v-model="modals.summary" :subgroup="subgroup" />

    <desition
      @desition="$event ? onDeleteSubgroup() : ''"
      v-model="modals.confirmDelete"
      title="Eliminar subgrupo"
      :description="modals.description"
    />

    <!-- <desition
      @desition="($event) ? renewSubgroup(): ''"
      v-model="modals.confirmRenew"
      title="Alerta"
      description="El subgrupo está a punto de terminar su periodo de vigencia. ¿Desea renovarlo?"
    /> -->

    <loading v-model="working.wLoading" text="Trabajando" />
    <success v-model="toast.success" text="Operación exitosa" />
    <error v-model="toast.failed" text="Ups ocurrió un error" />
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import desition from '../../Dialogs/Confirm'
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'

import CreateSubgroup from '../../Sections/Subgroups/CreateSubgroupModal'
import EditSubgroup from '../../Sections/Subgroups/EditSubgroupModal'
import SummarySubgroup from '../../Sections/Subgroups/SummarySubgroupModal'
import CustomTooltipOverflowText from '../../generic/custom_tooltip_overflow_text.vue'

export default {
  components: {
    loading,
    success,
    error,
    desition,
    CreateSubgroup,
    EditSubgroup,
    SummarySubgroup,
    CustomTooltipOverflowText,
  },
  data: () => ({
    selected: [],
    permits: [],
    user: {},
    pagination: {
      sortBy: 'name',
    },
    filters: {
      search: '',
    },
    search: '',
    flags: {
      loading: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    modals: {
      createSubgroup: false,
      confirmDelete: false,
      confirmRenew: false,
      editSubgroup: false,
      renewSubgroup: false,
      summary: false,
      description: '',
    },
    working: {
      wSubgroups: false,
      wLoading: false,
    },
    subgroups: [],
    subgroup: null,
    totalItemsFromBackend: 0,
    headers: [
      {
        text: 'Nivel',
        value: 'level.typeLevel',
        // width: "1%",
        sortable: false,
        align: 'center',
      },
      {
        text: 'Grado',
        value: 'gradeGroup.grade',
        sortable: false,
        align: 'center',
        // width: "1%",
      },
      {
        text: 'Grupo',
        value: 'gradeGroup.group',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Subgrupo',
        value: 'name',
        align: 'center',
      },
      {
        text: 'Días',
        value: '',
        class: 'days-column',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Estatus',
        value: '',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Inicio',
        value: '',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Fin',
        value: '',
        sortable: false,
        align: 'center',
      },
      {
        text: '',
        value: '',
        class: 'action-column',
        sortable: false,
        align: 'center',
      },
    ],
    levels: [],
  }),
  filters: {
    daysFilter: function (subgroup) {
      var daysSelected = []
      const DAYS = {
        monday: 'Lunes',
        tuesday: 'Martes',
        wednesday: 'Miércoles',
        thursday: 'Jueves',
        friday: 'Viernes',
        saturday: 'Sábado',
        sunday: 'Domingo',
      }
      for (const propName in DAYS) {
        if (
          Object.hasOwnProperty.call(DAYS, propName) &&
          Object.hasOwnProperty.call(subgroup, propName) &&
          subgroup[propName]
        ) {
          daysSelected.push(DAYS[propName])
        }
      }
      return daysSelected.join(' - ')
    },
  },
  methods: {
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.$refs.subgroupsTable.filteredItems.slice()
    },
    editSubgroup(subgroup) {
      this.subgroup = subgroup
      this.modals.renewSubgroup = this.modals.createSubgroup = false
      this.modals.editSubgroup = true
    },
    renewSubgroupConfirm(subgroup) {
      this.subgroup = subgroup
      this.modals.createSubgroup = false
      this.modals.confirmRenew = true
    },
    renewSubgroup(subgroup) {
      this.subgroup = subgroup
      this.modals.createSubgroup = false
      this.modals.renewSubgroup = this.modals.editSubgroup = true
    },
    viewSubgroup(subgroup) {
      this.subgroup = subgroup
      this.modals.summary = true
    },
    deleteSubgroups() {
      this.modals.confirmDelete = true
      this.modals.description = `Se eliminirán todos los grupos subgrupos del grupo <br> ${this.selected
        .map((i) => i.name)
        .join('<br>')} <br> ¿Desea continuar?`
    },
    onDeleteSubgroup() {
      this.working.wLoading = true
      this.$store
        .dispatch(
          'subgroups/deleteSubgroup',
          this.selected.map((i) => i.id)
        )
        .then(() => {
          this.working.wLoading = false
          this.toast.success = true
          this.selected = []
          this.getSubgroups()
          this.$forceUpdate()
        })
        .catch(() => {
          this.toast.failed = true
          this.working.wLoading = false
        })
    },
    onCancel() {
      this.modals.editSubgroup = false
      this.modals.renewSubgroup = false
      this.modals.createSubgroup = false
      this.modals.confirmDelete = false
      this.modals.summary = false
      this.$forceUpdate()
    },
    onLoading(show) {
      this.working.wLoading = show
    },
    onEditSubgroup(success, subgroup) {
      if (success) {
        this.modals.renewSubgroup = this.modals.editSubgroup = false
        subgroup.level = this.subgroup.level
        subgroup.gradeGroup = this.subgroup.gradeGroup
        this.subgroups.splice(
          this.subgroups.indexOf(this.subgroup),
          1,
          subgroup
        )
        this.subgroup = null
        this.toast.success = true
        this.toast.failed = false

        this.$forceUpdate()
      } else {
        this.toast.failed = true
        this.toast.success = false
      }
    },
    onNewSubgroup(event) {
      this.working.wLoading = false
      if (event.success) {
        event.new = true
        this.modals.createSubgroup = false
        this.toast.success = true
        this.getSubgroups(true)
      } else {
        this.toast.failed = true
      }
    },
    mapPermits() {
      var usr = this.getUser
      var wbRol = usr.webRole
      var catalogs = wbRol.catalogs
      for (var c in catalogs) {
        if (catalogs[c].name.includes('SUBGROUPS')) {
          this.permits[catalogs[c].name] = 1
        }
      }
      this.wSubgroups = this.permits['WATCH_SUBGROUPS'] ? true : false
    },
    filterSearch(clean) {
      if (!clean) {
        this.filters.search = this.search ? this.search : ''
      } else {
        this.filters.search = ''
      }
      if (!this.working.wLoading) {
        this.getSubgroups(true)
      }
    },
    createNewSubgroup() {
      this.getLevels()
    },
    getLevels() {
      this.$store
        .dispatch('subgroups/possibleLevels', this.getUser.branch.id)
        .then((response) => {
          this.levels = response.data
          this.modals.createSubgroup = true
          this.$forceUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getSubgroups(forceUpdate) {
      var offset = (this.pagination.page - 1) * this.pagination.rowsPerPage
      this.working.wSubgroups = true
      this.$store
        .dispatch('subgroups/getSubgroups', {
          search: this.filters.search,
          page_size: this.pagination.rowsPerPage,
          offset: offset,
        })
        .then((response) => {
          this.working.wSubgroups = false
          this.subgroups = response.data.items
          this.totalItemsFromBackend = response.data.total
          if (forceUpdate) {
            this.$forceUpdate()
          }
        })
        .catch(() => {
          this.working.wSubgroups = false
        })
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.onCancel()
      }
    },
    // onCancel() {
    //   this.modals.summary =
    //   this.modals.editSubgroup =
    //   this.modals.createSubgroup =
    //   this.modals.confirmDelete = false;
    //   this.$forceUpdate();
    // },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
  mounted() {
    if (this.getUser.id) this.mapPermits()
    if (this.permits['WATCH_SUBGROUPS'] && !this.subgroups.length > 0) {
      this.getSubgroups(true)
    }
  },
  watch: {
    getUser() {
      if (this.getUser.id) this.mapPermits()
      if (this.permits['WATCH_SUBGROUPS'] && !this.subgroups.length > 0) {
        this.getSubgroups(true)
      }
    },
    pagination: {
      handler() {
        if (
          this.pagination.rowsPerPage &&
          this.pagination.page &&
          this.pagination.sortBy
        ) {
          this.filters.size = this.pagination.rowsPerPage
          this.filters.offset =
            (this.pagination.page - 1) * this.pagination.rowsPerPage
          this.filters.orderBy = this.pagination.sortBy
          this.filters.orderType = this.pagination.descending ? 'DESC' : 'ASC'
          if (this.permits['WATCH_SUBGROUPS']) {
            this.getSubgroups(true)
          }
        }
      },
    },
  },
  computed: {
    ...mapGetters(['getUser']),
    subgroupsMod() {
      const today = new Date()
      const millisecondsPerDay = 1000 * 60 * 60 * 24

      return this.subgroups.map((e) => {
        e.statusText = e.status == 'ACTIVE' ? 'Vigente' : 'Terminado'
        e.finalDate = new Date(e.end)
        e.finalDate.setMinutes(
          e.finalDate.getMinutes() + e.finalDate.getTimezoneOffset()
        )
        e.startDate = new Date(e.start)
        e.startDate.setMinutes(
          e.startDate.getMinutes() + e.startDate.getTimezoneOffset()
        )

        e.finalDateText = isNaN(e.finalDate.getTime())
          ? '-'
          : moment(e.end).format('DD/MM/YYYY')
        e.startDateText = isNaN(e.startDate.getTime())
          ? '-'
          : moment(e.start).format('DD/MM/YYYY')
        if (e.finalDate) {
          var millisBetween = e.finalDate.getTime() - today.getTime()
          var days = Math.round(millisBetween / millisecondsPerDay)

          e.expireWarning = days < 6 && e.status == 'ACTIVE'
        } else {
          e.expireWarning = false
        }
        return e
      })
    },
  },
}
</script>

<style>
.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}
.subgroups-wrapper table.v-datatable.v-table > thead,
.subgroups-wrapper table.v-datatable.v-table > tbody {
  /* display: table-header-group; */
}

.subgroups-wrapper table.v-datatable.v-table > tbody {
  max-height: calc(106vh - 426px);
  min-height: calc(106vh - 426px);
  /* margin-bottom: 150px; */
}

.subgroups-wrapper table.v-datatable.v-table td {
  text-align: left !important;
}
.subgroups-wrapper .days-column {
  min-width: 200px;
}
.subgroups-wrapper .action-column {
  min-width: 210px;
}
.subgroups-wrapper .v-table__overflow {
  padding-bottom: 25px;
}
</style>
<style scoped>
.expiration-warning {
  color: #f99b0d;
}
.expiration-warning i {
  color: #f99b0d;
}

.expiration-warning.canRenovate {
  cursor: pointer;
}

.td-cell-150 {
  width: 150px;
  max-width: 150px;
  min-width: 150px;
}
.td-cell-250 {
  width: 250px;
  max-width: 250px;
  min-width: 250px;
}
/deep/ .table-full .v-datatable.v-table > tbody {
  max-height: calc(105vh - 426px);
  min-height: calc(105vh - 426px);
}
</style>
